( function () {
    'use strict';
    espresso.ecom.inpageModalCart = {};
    espresso.ecom.inpageModalCart.init = function () {
        var jInpageModalCart = jQuery( '#inpage-modal-cart' ),
            eInpageModalCartID = jInpageModalCart.find( 'input[name="eInpageModalCartID"]' ).val();
        if ( jQuery.cookie( 'eDisableInpageModalCart' ) !== 'true' && eInpageModalCartID !== jQuery.cookie( 'eInpageModalCartID' ) ) {
            jInpageModalCart.on( 'shown', function () {
                jQuery( this ).find( 'button[data-dismiss="modal"]' ).first().focus();
            } ).on( 'hide', function () {
                jQuery( this ).find( 'button[data-dismiss="modal"]' ).first().blur();
            } ).modal( {
                show: true
            } );
            jQuery.cookie( 'eInpageModalCartID', eInpageModalCartID, {
                path: '/'
            } );
        }
        jInpageModalCart.find( 'button' ).on( 'click', function () {
            if ( jInpageModalCart.find( 'input[name="eDisableInpageModalCart"]' ).prop( 'checked' ) === true ) {
                jQuery.cookie( 'eDisableInpageModalCart', 'true', {
                    path: '/'
                } );
            }
        } );
    };
}() );
